import React from 'react';
import { SearchFiltersDates } from './dates/SearchFiltersDates';
import { SearchFiltersCategory } from './categories/SearchFiltersCategory';
import {
  Connect,
  PropsFromRedux,
} from './SearchFiltersBarLegislationContainer';
import { ExactDateSelectors } from '../aside-filters/dates/exact-selection/ExactDateSelectors';
import {
  filterActionTypes,
  reportFilterToggle,
} from '../mobile-actions/filtersUtils';
import { SearchFilterBarItem } from './SearchFilterBarItem';

type Props = PropsFromRedux;

const RawSearchFiltersBarLegislation: React.FunctionComponent<Props> = ({
  hasDateSelected,
  hasTextCodeSelected,
  hasCollectiveAgreementsSelected,
  hasOtherLegislationSelected,
  shouldDisplayTextCode,
  shouldDisplayOtherLegislation,
  shouldDisplayCollectiveAgreements,
  dateLabel,
  textCodeCount,
  collectiveAgreementsCount,
  otherLegislationCount,
  type,
}) => {
  function track(actionType: filterActionTypes, value: boolean) {
    reportFilterToggle(type, actionType, value);
  }

  return (
    <>
      <SearchFilterBarItem>
        <SearchFiltersDates
          label={dateLabel}
          isSelected={hasDateSelected}
          track={track}
        >
          <ExactDateSelectors type="law" />
        </SearchFiltersDates>
      </SearchFilterBarItem>

      {shouldDisplayTextCode && (
        <SearchFilterBarItem>
          <SearchFiltersCategory
            count={textCodeCount}
            type="textCode"
            isSelected={hasTextCodeSelected}
            track={track}
            searchType="law"
          />
        </SearchFilterBarItem>
      )}
      {shouldDisplayOtherLegislation && (
        <SearchFilterBarItem>
          <SearchFiltersCategory
            count={otherLegislationCount}
            type="otherLegislation"
            isSelected={hasOtherLegislationSelected}
            track={track}
            searchType="law"
          />
        </SearchFilterBarItem>
      )}
      {shouldDisplayCollectiveAgreements && (
        <SearchFilterBarItem>
          <SearchFiltersCategory
            count={collectiveAgreementsCount}
            type="collectiveAgreements"
            isSelected={hasCollectiveAgreementsSelected}
            track={track}
            searchType="law"
          />
        </SearchFilterBarItem>
      )}
    </>
  );
};

export const SearchFiltersBarLegislation = Connect(
  RawSearchFiltersBarLegislation,
);
